import clsx from 'clsx';

import Input from '../Input';
import IconClear from '../IconClear';

const SearchBar: typeof Input = ({
  value,
  onChange,
  inputClassName,
  ...props
}) => {
  return (
    <Input
      placeholder="Search"
      {...props}
      value={value}
      onChange={onChange}
      inputClassName={clsx(inputClassName, 'pr-xl min-w-[32rem]')}
      suffix={
        value &&
        !!String(value).length && <IconClear onClick={() => onChange?.('')} />
      }
    />
  );
};

export default SearchBar;
